import util from '@bmp-vue/core/api/util'

const controller = 'Enum'
export default Object.assign({}, util.GetCrud(controller, ['none']),
  {
    TipoPerfilOperador: {
      Nenhum: 0,
      Administrador: 1,
      Operador: 1 << 1
    },
    TipoOperadorRetaguarda : {
      nenhum: "Nenhum",
      consulta: "Consulta",
      administrador: "Administrador"
    },
    TipoResponseContextoCadastros: {
      Sucesso: 0,
      Alerta: 1,
      Erro: 2
    }
  }
)
